import { fromJS } from 'immutable';
import { SHOW_BANNER } from 'reporting-data/constants/deprecate/deprecationTypes';
import { getReportConfig, getMetricPropertiesFromConfig, getDimensionFromConfig, getCustomFilterProperties, getFilterGroupsProperties, getRawDataType, getObjectTypeId } from 'reporting-data/report/configReportGetters';
import { CRM_OBJECT } from 'reporting-data/constants/dataTypes';
import { SHOW_DEAL_SPLIT_DEPRECATION_BANNER } from 'reporting-data/constants/gates';
import { DEAL_SPLIT } from 'reporting-snowflake/relational/metadata/objectTypes';
const DEAL_SPLIT_PROPERTIES = ['hs_all_deal_split_owner_ids', 'hs_num_associated_deal_splits'];
const usesDealSplitObject = report => {
  const config = getReportConfig(report);
  if (!config) {
    return false;
  }
  const dataType = getRawDataType(report);
  const objectTypeId = getObjectTypeId(report);
  if (dataType === CRM_OBJECT && objectTypeId === DEAL_SPLIT) {
    return true;
  }
  const metricProperties = getMetricPropertiesFromConfig(config).toJS();
  if (metricProperties.some(prop => DEAL_SPLIT_PROPERTIES.includes(prop))) {
    return true;
  }
  const dimensions = getDimensionFromConfig(config).toJS();
  if (dimensions.some(dim => DEAL_SPLIT_PROPERTIES.includes(dim))) {
    return true;
  }
  const customFilterProperties = getCustomFilterProperties(config).toJS();
  if (customFilterProperties.some(prop => DEAL_SPLIT_PROPERTIES.includes(prop))) {
    return true;
  }
  const filterGroupProperties = getFilterGroupsProperties(config).toJS();
  if (filterGroupProperties.some(prop => DEAL_SPLIT_PROPERTIES.includes(prop))) {
    return true;
  }
  return false;
};
export const singleDealSplitDeprecation = (report, userInfo) => {
  var _userInfo$gates;
  if (!(userInfo !== null && userInfo !== void 0 && (_userInfo$gates = userInfo.gates) !== null && _userInfo$gates !== void 0 && _userInfo$gates.includes(SHOW_DEAL_SPLIT_DEPRECATION_BANNER))) {
    return report;
  }
  return usesDealSplitObject(report) ? report.set('deprecation', fromJS({
    isDeprecated: true,
    type: SHOW_BANNER,
    message: 'dealSplitObjectChanged'
  })) : report;
};
export default singleDealSplitDeprecation;